import palette from '../palette';

export default {
	h1: {
		color: palette.text.primary,
		fontWeight: 700,
		fontSize: '3rem !important',
		letterSpacing: '-0.24px',
	},
	h2: {
		color: palette.text.primary,
		fontWeight: 700,
		fontSize: '2rem !important',
		letterSpacing: '-0.24px',
	},
	h3: {
		color: palette.text.primary,
		fontWeight: 700,
		fontSize: '2rem',
	},
	h4: {
		color: palette.text.primary,
		fontWeight: 600,
		fontSize: '20px',
		letterSpacing: '-0.06px',
		lineHeight: '24px'
	},
	h5: {
		color: palette.text.primary,
		fontWeight: 600,
		fontSize: '1.5rem !important',
	},
	h6: {
		color: palette.text.primary,
		fontWeight: 600,
		fontSize: '1.25rem !important',
	},
	subtitle1: {
		color: palette.text.primary,
		fontWeight: 400,
		fontSize: '0.875rem',
	},
	subtitle2: {
		color: palette.text.secondary,
		fontWeight: 400,
		fontSize: '0.875rem',
	},
	body1: {
		color: palette.text.primary,
		fontWeight: 300,
		fontSize: '1.125rem',
		letterSpacing: '-0.05px',
		lineHeight: '28px'
	},
	body2: {
		color: palette.text.secondary,
		fontWeight: 400,
		fontSize: '1rem',
		letterSpacing: '-0.04px',
		lineHeight: '18px'
	},
	button: {
		color: palette.text.primary,
		fontWeight: 400,
		fontSize: '1.125rem'
	},
	caption: {
		color: palette.text.secondary,
		fontWeight: 400,
		fontSize: '11px',
		letterSpacing: '0.33px',
		lineHeight: '13px'
	},
	overline: {
		color: palette.text.secondary,
		fontSize: '11px',
		fontWeight: 500,
		letterSpacing: '0.33px',
		lineHeight: '13px',
		textTransform: 'uppercase'
	}
};
